module.exports = {"141026100":"府城镇","141026101":"和川镇","141026102":"唐城镇","141026103":"冀氏镇","141026104":"良马镇","141026105":"马壁镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141026.json
// module id = 455
// module chunks = 0